import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import Image from "next/image";
import classNames from "classnames";
import Link from "@/components/UI/Link/Link";
import Card from "@/components/UI/Card/Card";
import Button from "@/components/UI/Button/Button";

interface Section28Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const HeaderAndButton = ({ job, page, section, ...props }: Section28Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        <div className="flex flex-col gap-10 md:flex-row md:gap-16 lg:gap-32">
          <div className="flex flex-1 flex-col gap-5">
            {section?.TextBlock1 && <div className="text-vpGray-700">{section?.TextBlock1}</div>}
            {section?.TextBlock2 && <div className="font-bold">{section?.TextBlock2}</div>}
            {section?.FeatureCards && (
              <div className="space-y-5">
                {section?.FeatureCards?.map((card: any) => {
                  return (
                    <Card className="flex gap-4 bg-white p-4" key={card?.id} rounded="large" shadow="none">
                      {card.Icon?.data?.attributes && (
                        <div
                          className={classNames(
                            "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg",
                            card?.IconContainerClassName
                          )}
                          style={card?.IconContainerStyle}
                        >
                          <div
                            className={classNames("h-7 w-7", card?.IconClassName)}
                            style={{
                              mask: `url(${card?.Icon?.data?.attributes?.url}) no-repeat center / contain`,
                              WebkitMask: `url(${card?.Icon?.data?.attributes?.url}) no-repeat center / contain`,
                              ...card?.IconStyle,
                            }}
                          />
                        </div>
                      )}
                      <div className="flex flex-col gap-1">
                        <div className="font-medium">{card?.Title}</div>
                        <div className="text-vpGray-700">{card?.Body}</div>
                      </div>
                    </Card>
                  );
                })}
              </div>
            )}
          </div>
          <div className="flex flex-1 flex-col gap-5 ">
            {section?.Image?.data?.attributes && (
              <div className="hidden lg:block lg:flex-1">
                <Image
                  alt={section?.Image?.data?.attributes?.alternativeText}
                  src={section?.Image?.data?.attributes?.url}
                  width={section?.Image?.data?.attributes?.width ?? "100"}
                  height={section?.Image?.data?.attributes?.height ?? "100"}
                  priority
                />
              </div>
            )}
            {section?.TextBlock3 && <div className="font-bold">{section?.TextBlock3}</div>}
            {section?.TextBlock4 && <div className="text-vpGray-700">{section?.TextBlock4}</div>}
            {section?.Button && (
              <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
                <Button
                  className="flex"
                  size="large"
                  startNode={
                    section.Button.StartNode?.data?.attributes && (
                      <div>
                        <div
                          className={classNames("h-5 w-5", section?.Button?.StartNodeClassName)}
                          style={{
                            mask: `url(${section?.Button?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                            WebkitMask: `url(${section?.Button?.StartNode?.data?.attributes?.url}) no-repeat center / contain`,
                          }}
                        />
                      </div>
                    )
                  }
                >
                  {section?.Button?.Value}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </SectionContainer>
    </Section>
  );
};

export default HeaderAndButton;
